import React from 'react';
import { stats } from '../../data/mockData';
import { Users, Briefcase, School, GraduationCap } from 'lucide-react';

const iconMap = {
  Users,
  Briefcase,
  School,
  GraduationCap
};

export const StatsSection = () => {
  return (
    <div className="bg-blue-600 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <div key={index} className="text-center">
                <div className="flex justify-center mb-3">
                  <div className="bg-white/20 p-3 rounded-lg">
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                </div>
                <p className="text-3xl lg:text-4xl font-bold text-white mb-1">{stat.value}</p>
                <p className="text-blue-100 text-sm lg:text-base">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
